import { useEffect, useState } from 'react';
import { ProviderValue, useAxios } from '../../config/axios-config';
import { PageLoader } from '../util/PageLoader';
import { ErrorPage } from '../error/ErrorPage';
import {DinneyUtil} from "../util/DinneyUtil";
import dayjs, {Dayjs} from "dayjs";
import {MealDateSummary} from "../../model/MealDateSummary";
import {MealDateResponseDTO} from "../../model/ResponsesDTO";
import ReactEcharts from "echarts-for-react"
import {EChartsOption} from "echarts-for-react/src/types";
import { GREY_PALLETE, ACTIVE_PALLETE } from '../util/DinneyConst';
import {MonthPickerComponent} from "../mealselection/MonthPickerComponent";
import {Row} from "react-bootstrap";
import {message} from "antd";
import {NoticeType} from "antd/lib/message/interface";

export const MealsDailySummaryPage = () => {

    const axiosInstance = useAxios() as ProviderValue
    const [options, setOptions] = useState<EChartsOption>({})
    const [pickedDate, setPickedDate] = useState<Dayjs>(dayjs().locale('pl'))
    const [monthSwitcher, setMonthSwitcher] = useState<boolean>(true)
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [messageApi, contextHolder] = message.useMessage()
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
        axiosInstance.get<MealDateResponseDTO>(`/mealdates/secure/fetch/allinmonth/${pickedDate.format('YYYY-MM-DD')}`, {signal})
            .then(response => {
                var mealDateSummaries : MealDateSummary[] = []
                var resp = response.data.mealDates
                if (resp !== undefined) {
                    mealDateSummaries = resp.map(md => new MealDateSummary(md.mealid, md.details, md.orderNumber, md.mealdays))
                    handleSort(true, mealDateSummaries)
                }
                setIsLoaded(true)
            }).catch((e : any) => {
            setIsLoaded(true)
            setIsError(true)
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        return () => {
            controller.abort()
        }
        //eslint-disable-next-line
    },[monthSwitcher])

    const handleSort = (descending: boolean, list? : MealDateSummary[]) => {
        let sortedMealList = [...list!].sort((a,b) => {
            return DinneyUtil.setOrder(a.orderNumber, b.orderNumber, a.mealid, b.mealid, descending)
        })
        handleSetOptions(sortedMealList)
    }

    const handleSetOptions = (list : MealDateSummary[]) => {
        let tempOptions = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'line' // 'shadow' as default; can also be 'line' or 'shadow'
                },
            },
            color: ACTIVE_PALLETE,
            legend: {},
            grid: {
               containLabel: true
            },
            xAxis: {
                type: 'value',
                min: 0,
            },
            yAxis: {
                type: 'category',
                padding: [3,1,3,1],
                inverse: true,
                min: 1,
                max: 31,
                axisLabel: {
                    formatter: (value : string) => value.substring(0,5),
                    interval: 0,
                },
                splitArea: {
                    show: true
                },
                data: Array.from({length: list.length > 0 ? list.at(0)!.mealdays.length : pickedDate.daysInMonth()+1}, (_, i) => `${pickedDate.date(i).format('DD/MM (dddd)')}`)
            },
            series: list.map((mealDateSummary, index) => {
                return {
                    name: mealDateSummary.details,
                    type: 'bar',
                    stack: 'total',
                    label: {
                        show: true,
                        formatter: (params : any) => params.value === 0 ? '' : params.value
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    itemStyle: {
                      color: (params : any) => {
                          if (params.dataIndex === dayjs().locale('pl').date() && pickedDate.month() === dayjs().locale('pl').month()) {
                              return ACTIVE_PALLETE[index]
                          }
                          return GREY_PALLETE[index]
                      }
                    },
                    data: mealDateSummary.mealdays
                }
            })
        }
        setOptions(tempOptions)
    }

    const copyEvent : Record<string, Function> = {
        'dblclick' : ((params : any) => {
            try {
                var message = `${params.name}: `
                options.series.forEach((series: any) => {
                    message = message + `${series.name}: ${series.data[params.dataIndex]}; `
                })
                if ("clipboard" in navigator) {
                    navigator.clipboard.writeText(message);
                } else {
                    document.execCommand("copy", true, message);
                }
                copyNotification(`Wiadomość: "${message}" skopiowano do schowka`, true)
            } catch (e) {
                copyNotification('Nie udało się skopiować do schowka', false)
                console.log(e)
            }
        })
    }

    const copyNotification = (message : string, success: boolean) => {
        let type : NoticeType = success ? 'success' : 'error'
        messageApi.open({
            type: type,
            content: message,
        });
    };

    if (!isLoaded) {
        return (
            <PageLoader />
        )
    }
    if (isError) {
        return (
            <ErrorPage />
        )
    }


    return (
        <div id={"lepage"}>
            <Row className='mb-3'>
                <MonthPickerComponent
                    key={'monthpicker'}
                    pickedDate ={pickedDate}
                    setPickedDate={setPickedDate}
                    setIsLoaded={setIsLoaded}
                    setMonthSwitcher={setMonthSwitcher}
                    isParent={false}
                />
            </Row>
            {contextHolder}
            <ReactEcharts
                key={'chart'}
                option={options}
                style={{ width: "100%", height: "120vh" }}
                onEvents={copyEvent}
            ></ReactEcharts>
        </div>
    )
}